import { Events } from './constants';
import { fetchMachineGuid, getUrlParameterByName } from './utils';
import { WidgetMetricService } from './services';

const WidgetMetric = (_apiUrl, _companyId, _modules, _token, _widgetConfiguration) => {
    const _buildSessionData = () => {
        const data = {
            machine_guid: fetchMachineGuid(),
            extra_params: {},
            referrer: document.referrer,
            preferred_language: navigator.language
        };
        const utmFields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        const urlParts = window.location.href.split('?');
        let paramList = [];

        if (urlParts.length > 1) {
            const queryString = urlParts[1];
            if (queryString.length) {
                const params = queryString.split('&');
                params.forEach(param => {
                    paramList.push(param.split('=')[0]);
                });
            }
        }

        if (!paramList || !paramList.length) {
            paramList = [...utmFields];
        }

        paramList.forEach(paramName => {
            const val = getUrlParameterByName(paramName);
            if (val) {
                if (utmFields.includes(paramName)) {
                    data[paramName] = val;
                } else {
                    data.extra_params[paramName] = val;
                }
            }
        });
        return data;
    };

    const startSession = () => {
        // Register our session
        const sessionData = _buildSessionData();
        WidgetMetricService.registerSession(_apiUrl, sessionData, _companyId, _modules, _token, _widgetConfiguration);

        // Add event listener to subsribe to module events
        window.addEventListener('CONVERSION_CLOUD_EVENT', evt => {
            const { type, payload } = evt.detail;

            if (!payload || !Object.keys(payload).length) {
                return;
            }

            const { companyId, module: moduleType, leadId } = payload;
            const data = payload.data || undefined;
            let updatedModuleType = moduleType;
            if (data && data.lead_via_company_id && updatedModuleType === 'MODULE_CONCESSIONMANAGER') {
                updatedModuleType = 'ULM_CONCESSION_MANAGER';
            }
            if (data && data.lead_via_company_id && updatedModuleType === 'MODULE_SCHEDULEGENIE') {
                updatedModuleType = 'ULM_SCHEDULE_GENIE';
            }
            let eventType;

            switch (type) {
                case Events.MODULE_OPENED:
                    eventType = Events.METRIC_WIDGET_OPENED;
                    break;
                case Events.LEAD_CREATED:
                    eventType = Events.METRIC_LEAD_CREATED;
                    break;
                case Events.CALL_CLICKED:
                    eventType = Events.METRIC_CALL_PLACED;
                    break;
                case Events.CHATBOT_INTERACTED:
                    eventType = Events.CHATBOT_INTERACTED;
                    break;
            }

            if (eventType) {
                WidgetMetricService.recordEvent(_apiUrl, _token, {
                    eventType,
                    moduleType: updatedModuleType,
                    companyId,
                    leadId,
                    data
                });
            }
        });
    };

    return {
        startSession
    };
};

export default WidgetMetric;
